module.exports = __webpack_public_path__ + "static/media/target.500c56dd.svg";